import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/ngos/')({
	beforeLoad: () => {
		throw redirect({ to: '/ngos/dashboard' });
	},
});
